var _defs, _path, _line, _line2, _circle, _circle2, _line3, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#7F7F7F;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M42,3a3.0034,3.0034,0,0,1,3,3V42a3.0034,3.0034,0,0,1-3,3H6a3.0034,3.0034,0,0,1-3-3V6A3.0034,3.0034,0,0,1,6,3H42m0-3H6A6.01763,6.01763,0,0,0,0,6V42a6.01763,6.01763,0,0,0,6,6H42a6.01765,6.01765,0,0,0,6-6V6a6.01765,6.01765,0,0,0-6-6Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.45899,
    y1: 13.71707,
    x2: 36.83399,
    y2: 13.71707
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.45899,
    y1: 24.71707,
    x2: 36.83399,
    y2: 24.71707
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.85802,
    cy: 13.80286,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.5,
    cy: 24.5,
    r: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.45899,
    y1: 35.71707,
    x2: 36.83399,
    y2: 35.71707
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.5,
    cy: 35.5,
    r: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListGrey);
export default __webpack_public_path__ + "static/media/icon-list-grey.88efebbc69c11ea853f2517d8e82291e.svg";
export { ForwardRef as ReactComponent };